<div class="pagetitle">
  <h2>Validate JSON</h2>
</div>
<p class="text-muted validate-intro">Check JSON media exports before you upload them to a project. Files are checked in your browser and never leave this computer.</p>
<alert></alert>

<div class="drop-zone mb-2" [class.active]="dropActive"
  (dragenter)="dragEnter($event)" (dragover)="$event.preventDefault()" (dragleave)="dragLeave()" (drop)="drop($event)">
  <div>
    <i class="fa fa-fw fa-upload mr-1" aria-hidden="true"></i>
    Drop JSON files or a folder here, or
    <button type="button" class="btn btn-link p-0 align-baseline" (click)="filesInput.click()">browse files</button>
    or
    <button type="button" class="btn btn-link p-0 align-baseline" (click)="folderInput.click()">choose a folder</button>
  </div>
  <div class="small text-muted">The same checks as a project upload. Up to 50 MB per file.</div>
  <input #filesInput type="file" multiple accept=".json,application/json" hidden (change)="browse(filesInput)">
  <input #folderInput type="file" webkitdirectory hidden (change)="browse(folderInput)">
</div>
@if (notice) {
  <div class="small text-muted">{{ notice }}</div>
}

@if (entries.length) {
  <section class="card results mt-3" aria-label="Results">
    <div class="card-header d-flex flex-wrap align-items-center justify-content-between py-2">
      <strong aria-live="polite">{{ summary }}</strong>
      <div>
        <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="checking" (click)="downloadReport()"><i class="fa fa-download" aria-hidden="true"></i> Download report</button>
        <button type="button" class="btn btn-sm btn-link" (click)="clear()">Clear</button>
      </div>
    </div>
    <ul class="list-group list-group-flush">
      @for (entry of entries; track entry.id) {
        @if (entry.check; as check) {
          @let status = statusOf(check);
          @let open = isOpen(entry);
          <li class="list-group-item p-0 result">
            <button type="button" class="result-toggle" [attr.aria-expanded]="hasDetails(check) ? open : null" [disabled]="!hasDetails(check)" (click)="entry.open = !open">
              <i class="fa fa-fw fa-lg {{ status.icon }}" aria-hidden="true"></i>
              <span class="result-text">
                <strong class="result-name text-truncate" [title]="check.name">{{ check.name }}</strong>
                <span class="result-meta small text-muted">{{ meta(check) }}</span>
              </span>
              <span class="result-status badge badge-pill {{ status.badge }}">{{ status.label }}</span>
              <i class="fa fa-fw fa-chevron-down text-muted result-chevron" [class.invisible]="!hasDetails(check)" [class.open]="open" aria-hidden="true"></i>
            </button>
            @if (open) {
              <div class="result-details">
                @if (check.problems.length) {
                  @let shown = shownProblems(entry);
                  <ul class="alert alert-danger list-unstyled findings mb-2">
                    @for (problem of shown; track $index) {
                      @let found = located(problem);
                      <li>@if (found.path) {<code>{{ found.path }}</code>} {{ found.message }}</li>
                    }
                    @if (check.problems.length > shown.length) {
                      <li><button type="button" class="btn btn-link alert-link p-0" (click)="entry.showAllProblems = true">Show {{ count(check.problems.length - shown.length, 'more problem') }}</button></li>
                    } @else if (check.problemCount > check.problems.length) {
                      <li class="font-weight-bold">…and {{ count(check.problemCount - check.problems.length, 'more problem') }}</li>
                    }
                  </ul>
                }
                @if (check.warnings.length) {
                  <div class="alert alert-warning mb-2">
                    <strong>Read in part by the loader (doesn't fail)</strong>
                    <ul class="list-unstyled findings mb-0">
                      @for (warning of check.warnings; track $index) {
                        @let found = located(warning);
                        <li>@if (found.path) {<code>{{ found.path }}</code>} {{ found.message }}</li>
                      }
                      @if (check.warningCount > check.warnings.length) {
                        <li class="font-weight-bold">…and {{ count(check.warningCount - check.warnings.length, 'more warning') }}</li>
                      }
                    </ul>
                  </div>
                }
              </div>
            }
          </li>
        } @else {
          <li class="list-group-item d-flex align-items-center result">
            <i class="fa fa-fw fa-lg text-muted mr-3 {{ entry.id === checkingId ? 'fa-spinner fa-spin' : 'fa-clock' }}" aria-hidden="true"></i>
            <span class="flex-grow-1 text-truncate" [title]="entry.name"><strong class="result-name">{{ entry.name }}</strong><span class="text-muted"> · {{ formatBytes(entry.file.size, 1) }}</span></span>
            <span class="result-status text-muted">{{ entry.id === checkingId ? 'Checking…' : 'Waiting' }}</span>
          </li>
        }
      }
    </ul>
  </section>
}
